export default "__VITE_ASSET__BsyePlKm__"